const selectors = {
  form: "[data-calculator-form]",
  formContent: "[data-calculator-form-content]",
  input: "[data-calculator-input]",
  inputAttribute: "data-calculator-input",
  hoverElement: "[data-blur-hover]",
  resetFormButton: "[data-calculator-reset]",
};

const elements = {
  form: null,
  inputs: null,
  hoverElements: null,
  formContent: null,
  resetFormButton: null,
};

const classes = {
  loading: "is-loading",
  completed: "is-completed",
  error: "error",
};

const namesForCalculations = {
  service_fee: {
    elements: ["ad_spend"],
    requirement: (value) => {
      if (value <= 20000) {
        return value * 1.5;
      } else if (value <= 100000) {
        return (
          value * (1.5 - (value - 20000) * ((1.5 - 0.55) / (100000 - 20000)))
        );
      } else if (value <= 500000) {
        return (
          value * (0.55 - (value - 100000) * ((0.55 - 0.2) / (500000 - 100000)))
        );
      } else {
        return value * 0.2;
      }
    },
    currency: true,
  },
  impressionen: {
    elements: ["ad_spend", "cpc", "ctr"],
    operator: "/",
    percent: true,
  },
  clicks: {
    elements: ["impressionen", "ctr"],
    operator: "*",
    percent: true,
  },
  lp_visits: {
    elements: ["clicks"],
    operator: "*",
  },
  leads: {
    elements: ["lp_visits", "cr_to_lead"],
    operator: "*",
    percent: true,
  },
  mqls: {
    elements: ["leads", "cr_to_mql"],
    operator: "*",
    percent: true,
  },
  sqls: {
    elements: ["mqls", "cr_to_sql"],
    operator: "*",
    percent: true,
  },
  sals: {
    elements: ["sqls", "cr_to_sal"],
    operator: "*",
    percent: true,
  },
  deals: {
    elements: ["sals", "cr_to_deal"],
    operator: "*",
    percent: true,
  },
  sum_of_deal_value: {
    elements: ["deals", "adv"],
    operator: "*",
    percent: false,
    currency: true,
  },
  roas: {
    elements: ["sum_of_deal_value", "ad_spend"],
    operator: "/",
    percent: false,
  },
  total_invest: {
    elements: ["ad_spend", "service_fee"],
    operator: "+",
    percent: false,
    currency: true,
  },
  total_return: {
    elements: ["sum_of_deal_value", "total_invest"],
    operator: "-",
    percent: false,
    currency: true,
  },
  roi: {
    elements: ["sum_of_deal_value", "total_invest"],
    operator: "/",
    percent: false,
  },
  cpl: {
    elements: ["clicks", "cpc"],
    operator: "*",
    percent: false,
    additionalCalculation: {
      elements: ["leads"],
      operator: "/",
    },
  },
  cpmql: {
    elements: ["cpl", "cr_to_mql"],
    operator: "/",
    percent: true,
  },
  cpsql: {
    elements: ["cpmql", "cr_to_sql"],
    operator: "/",
    percent: true,
  },
  cpsal: {
    elements: ["cpsql", "cr_to_sal"],
    operator: "/",
    percent: true,
  },
  cpa: {
    elements: ["cpsal", "cr_to_deal"],
    operator: "/",
    percent: true,
  },
  sum_of_deal_margin: {
    elements: ["deals", "amd"],
    operator: "*",
    percent: false,
    currency: true,
  },
  total_return_margin: {
    elements: ["sum_of_deal_margin", "total_invest"],
    operator: "-",
    percent: false,
    currency: true,
  },
  roas_margin: {
    elements: ["sum_of_deal_margin", "ad_spend"],
    operator: "/",
    percent: false,
  },
  roi_margin: {
    elements: ["sum_of_deal_margin", "total_invest"],
    operator: "/",
    percent: false,
  },
};

function getValues(elementsNameList) {
  return elementsNameList.map((name) =>
    formattingString2Number(
      [...elements.inputs].find(
        (input) => input.getAttribute(selectors.inputAttribute) === name
      ).value || "0"
    )
  );
}

function calculateValue(values = [], operator = "/") {
  const operators = {
    "/": (a, b) => a / b,
    "*": (a, b) => a * b,
    "+": (a, b) => a + b,
    "-": (a, b) => a - b,
  };

  return Number(
    values.reduce((acc, val) => {
      if (acc) return operators[operator](acc, val);

      return acc;
    })
  );
}

function formattingString2Number(string) {
  return Number(string.replace(/[^\d.-]+/g, "").replace(/\,/g, ""));
}

function togglesInputError(inputs = [], action = "add") {
  [...inputs].map((input) =>
    input.parentElement.classList[action](classes.error)
  );
}

function calculateValues() {
  [...elements.inputs].map((inputElement) => {
    const valueAttr = inputElement.getAttribute(selectors.inputAttribute);

    if (namesForCalculations[valueAttr]) {
      const {
        operator,
        percent: isPercent,
        elements: elementsNameList,
        additionalCalculation,
        requirement,
        currency,
      } = namesForCalculations[valueAttr];
      const el = [...elements.inputs].find(
        (input) => input.dataset.calculatorInput === valueAttr
      );

      if (el) {
        const values = getValues(elementsNameList);

        let value = calculateValue(values, operator);

        if (isPercent) {
          if (operator === "/") value = value * 100;
          if (operator === "*") value = value / 100;
        }

        if (additionalCalculation) {
          const additionalValue = calculateValue(
            getValues(additionalCalculation.elements)
          );

          value = calculateValue([value, additionalValue], "/");
        }

        if (requirement) {
          value = requirement(value);
        }

        if (value === Infinity) return (el.value = 0);
        if (isNaN(value)) return (el.value = "-");
        if (value === 0) return (el.value = "-");
        return (el.value = Number(value.toFixed(2)).toLocaleString(
          "en-US",
          currency ? { style: "currency", currency: "EUR" } : {}
        ));
      }
    }
  });
}

function handleFormChange(e) {
  // if (e.target.required) {
  //   togglesInputError([e.currentTarget], "remove");
  // }

  togglesInputError(elements.inputs, "remove");

  e.currentTarget.value = formattingString2Number(
    e.target.value
  ).toLocaleString("en-US");
}

async function sendForm(data) {
  elements.form.classList.add(classes.completed);

  const body = Object.keys(data).reduce((acc, key) => {
    return { ...acc, [key]: formattingString2Number(data[key]) };
  }, {});

  try {
    const response = await fetch("/wp-json/v1/calculator", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
  } catch (err) {
    console.log("err", err);
  } finally {
    elements.form.classList.remove(classes.loading);
  }
}

function handleSubmitForm(e) {
  e.preventDefault();

  const requiredInputs = [...elements.inputs]
    .filter((input) => input.hasAttribute("required") && input.value === "0")
    .filter((input, _, arr) => {
      const inputsAttr = ["adv", "amd"];
      const inputs = [...arr].filter(
        (i) =>
          inputsAttr.includes(i.getAttribute(selectors.inputAttribute)) &&
          i.value === "0"
      );

      if (inputsAttr.includes(input.getAttribute(selectors.inputAttribute))) {
        if (inputs.length === 2) return input;
        return false;
      }

      return input;
    });

  if (requiredInputs.length) return togglesInputError(requiredInputs, "add");

  calculateValues();
  calculateValues();

  const formData = new FormData(e.target);
  const formProps = Object.fromEntries(formData);

  sendForm(formProps);
}

function handleMouseEnter(e) {
  const selectedValueInput = e.currentTarget.getAttribute("data-blur-hover");

  elements.formContent.setAttribute("show-input", selectedValueInput);
}

function handleMouseLeave(e) {
  elements.formContent?.removeAttribute("show-input");
}

function resetForm() {
  document.querySelector('[data-calculator-input="ad_spend"]').value = 0;
  document.querySelector('[data-calculator-input="adv"]').value = 0;
  document.querySelector('[data-calculator-input="amd"]').value = 0;

  calculateValues();
  calculateValues();
  elements.form.classList.remove(classes.completed);
}

const calculatorInit = () => {
  elements.form = document.querySelector(selectors.form);
  elements.inputs = document.querySelectorAll(selectors.input);
  elements.hoverElements = document.querySelectorAll(selectors.hoverElement);
  elements.formContent = document.querySelector(selectors.formContent);
  elements.resetFormButton = document.querySelectorAll(
    selectors.resetFormButton
  );

  if (!elements.inputs?.length) return null;

  [...elements.inputs].map((input) =>
    input.addEventListener("input", handleFormChange)
  );

  [...elements.hoverElements].map((el) => (el.onmouseover = handleMouseEnter));
  [...elements.hoverElements].map(
    (el) => (el.onmouseout = () => handleMouseLeave(el))
  );

  [...elements.resetFormButton].map((button) =>
    button.addEventListener("click", resetForm)
  );
  elements.form.addEventListener("submit", handleSubmitForm);
};

export default calculatorInit;
